module.exports = __webpack_public_path__ + "img/icon-warning-snø-4.645a6422.svg";